import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../admin/api/api";
import { image_base_url } from "../admin/api/api";
import "./TopSelling.scss";

const NewArrival = () => {
  //const BASE_URL = "http://localhost:5170";
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
      loadNewArrivalProducts();
    }, []);

  const loadNewArrivalProducts = async () => {
    try {
      const res = await api.get("/public/products/newarrival");
      setProducts(res.data);
    } catch (error) {
      console.error("Error fetching new arrival products:", error);
    }
  };

  return (
    <div className=" box-shadow-normal">
      <h4 className="mb-3 pt-3 fw-bold">New Arrivals</h4>
      <p className="section-subtitle">
          Discover the latest trends just arrived at Swara Collection
      </p>

      <div className="top-selling-slider">
        {products?.map((item) => (
          <Card
            key={item.productId}
            className="top-selling-card"
            onClick={() => navigate(`/product/${item.productId}`)}
          >
            <Card.Img
                          variant="top"
                          src={
                            item.image
                              ? image_base_url + item.image
                              : "/images/no-image.png"
                          }
                          alt={item.name}
                          className="top-selling-img"
                        />
            <Card.Body>
                <Card.Title style={{fontSize : "13px" , fontWeight :"bold"}}>{item.productName}</Card.Title>
                <div className="fw-bold">₹ {item.price}</div>
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default NewArrival;